export const ParentValidationSchema = (json) => {

    console.log("json",json);
    
    const MyPromiss = new Promise((resolve, reject) => {
      var errorJson = {};
  
      // Helper function to safely handle string operations
      const safeStringTrim = (value) => {
        if (value === null || value === undefined) return '';
        return typeof value === 'string' ? value.trim() : String(value).trim();
      };
  
      // Required fields validation
      if (!json?.name || safeStringTrim(json.name) === "") {
        Object.assign(errorJson, { name: "Service name cannot be empty *" });
      }
  
      resolve(errorJson);
    });
  
    return MyPromiss;
  };